/** biome-ignore-all lint/a11y/noStaticElementInteractions: this is ok */

import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Observe } from 'rewire-core';
import { FormView, Modal, WithStyle, withStyles } from 'rewire-ui';
import Routes from '../Routes';
import authService from '../services/AuthService';
import Dialog from '../ui/Dialog2';
import TitleWithFlowLogo from '../ui/TitleWithFlowLogo';
import { Link } from '../utility/Link';
import Confirmation from './Confirmation';
import forgotPasswordModel from './ForgotPasswordModel';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    height: '100vh',
    backgroundColor: theme.palette.primary.main,
  },
  confirmationContentContainer: {
    alignItems: 'stretch',
  },
  confirmationContentInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
    justifyContent: 'space-between',
  },
  link: {
    color: theme.palette.secondary.main,
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover, &:active': {
      color: theme.palette.secondary.dark,
    },
  },
  checkEmailTitle: {
    paddingTop: '15px',
  },
});

interface IForgotPasswordProps {}

type ForgotPasswordProps = WithStyle<ReturnType<typeof styles>, IForgotPasswordProps & RouteComponentProps<any>>;

class ForgotPassword extends React.Component<ForgotPasswordProps> {
  constructor(props: ForgotPasswordProps) {
    super(props);

    forgotPasswordModel.load();
  }

  componentWillUnmount() {
    forgotPasswordModel.reset();
  }

  handleNoEmailClick = (_evt: React.MouseEvent) => {
    forgotPasswordModel.reset();
  };

  renderTitle = (_dialog: Modal): JSX.Element => {
    return <TitleWithFlowLogo beforeText="Forgot" afterText="Password" />;
  };

  renderCustomConfirmationTitle(): JSX.Element {
    const { classes } = this.props;

    return (
      <Typography align="center" variant="h5" className={classes.checkEmailTitle}>
        Please check your email
      </Typography>
    );
  }

  renderCustomConfirmationContents = React.memo((): JSX.Element => {
    const { classes } = this.props;

    return (
      <>
        <div>
          <Typography align="center" paragraph={true}>
            Once you click the link we sent you in your email, you will be able to reset your password
          </Typography>
          <Typography align="center" paragraph={true} variant="body2">
            Didn&apost receive an email?{' '}
            <span className={classes.link} onClick={this.handleNoEmailClick}>
              Click here.
            </span>
          </Typography>
        </div>
        <Link to={Routes.Root} className={classes.link}>
          <Typography align="right" variant="body2">
            Return to landing
          </Typography>
        </Link>
      </>
    );
  });

  renderDialogContents = React.memo((): JSX.Element => {
    return (
      <Observe
        render={() => (
          <FormView form={forgotPasswordModel.form} onSubmit={forgotPasswordModel.actionFn('submit')}>
            <div className="content">
              <forgotPasswordModel.form.field.email.Editor className="span1" />
            </div>
          </FormView>
        )}
      />
    );
  });

  render() {
    const { from } = (this.props.location.state as { from: string }) || { from: { pathname: Routes.Home } };
    const { classes } = this.props;

    return (
      <Observe
        render={() => {
          if (authService.isAuthenticated) {
            return <Redirect to={from} />;
          }

          return (
            <div className={classes.root}>
              {forgotPasswordModel.isComplete ? (
                <Confirmation
                  type="custom"
                  message={this.renderCustomConfirmationTitle()}
                  classes={{
                    contentContainer: classes.confirmationContentContainer,
                    contentInnerContainer: classes.confirmationContentInnerContainer,
                  }}
                >
                  <this.renderCustomConfirmationContents />
                </Confirmation>
              ) : (
                <Dialog
                  dialog={forgotPasswordModel}
                  hideBackdrop={true}
                  disableTransition={true}
                  title={this.renderTitle}
                  maxWidth="xs"
                >
                  <this.renderDialogContents />
                </Dialog>
              )}
            </div>
          );
        }}
      />
    );
  }
}

export default withStyles(styles, ForgotPassword);
